<div class="main-container" >

    @if (isEmailSubmitted) {
      <div class="text-gray-900 my-3 w-20rem ">
        {{submitMessage}}
      </div>
    } @else {
      <div class="text-2xl text-gray-900 my-3">
        Forgot Password ?
      </div>
      <div>
        <form [formGroup]="forgotPasswordForm" (ngSubmit)="onSubmit()" class="w-20rem flex flex-column gap-3">


          <div class="flex flex-column flex-1 ">
            <label for="email" class="text-xs font-medium mb-1">Email </label>
            <input
              type="text"
              id="email"
              pInputText
              placeholder="Enter your work email"
              formControlName="email"
            />
            <app-form-error-message [formGroup]="forgotPasswordForm" fieldName="email" displayName="Email" />
          </div>

          <button type="submit" pButton class="w-full flex justify-content-center text-sm font-medium" [disabled]="forgotPasswordForm.invalid || isSubmitting">
            @if (isSubmitting) {
              <i class="pi pi-spin pi-spinner mr-2"></i> Submitting...
            }@else {
              Submit
            }
          </button>
        </form>
      </div>

    }

    @if(!isEmailSubmitted) {
      <div
          class="text-xs font-medium underline text-black-alpha-70 cursor-pointer mt-3"
          (click)="handleForgotPassword()"
        >
          Back to login form
      </div>
    }
</div>
